import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { InstructorModel } from '../models/instructor.model';
import { ReportModel } from '../models/report.model';
import { ResultModel } from '../models/result.model';

@Injectable({
  providedIn: 'root'
})
export class ReportService extends BaseService {


  downloadInstructors(reportModel: ReportModel) {
    return this.httpClient.get<ResultModel>(this.getApiUrl(`report/virtual-classes/all-instructors?pYear=${reportModel.Year}&pMonth=${reportModel.Month}`));
  }

  downloadInstructor(reportModel: ReportModel) {
    return this.httpClient.get<ResultModel>(this.getApiUrl(`report/virtual-classes/instructor?pYear=${reportModel.Year}&pMonth=${reportModel.Month}&pInstructorID=${reportModel.InstructorID}`));
  }

  downloadInstructorsquestioncount(reportModel: ReportModel) {
    let dateOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
    let pStartDate = reportModel.StartDate.toLocaleDateString('tr-TR', dateOptions);
    let pEndDate = reportModel.EndDate.toLocaleDateString('tr-TR', dateOptions);
    return this.httpClient.get<ResultModel>(this.getApiUrl(`report/questions/all-instructors?pStartDate=${pStartDate}&pEndDate=${pEndDate}`));
  }

}
